import { Icon } from "@thetreep/ui";

export interface FieldErrorProps {
  error?: string;
}

export function FieldError({ error }: FieldErrorProps) {
  if (error === undefined) {
    return;
  }
  return (
    <div className="flex gap-2 my-2">
      <Icon src="warning_fill" size={16} color={"#eb5757"} />
      <span className="text-xs">{error}</span>
    </div>
  );
}
